/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactElement, useState, useMemo, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Table, GoBackButton } from '~/components';

import { profileCodes } from '../Main';

import * as S from './styles';

interface IProfileCodeListRouteState {
  profileCodeId: string;
}

interface IProfileCodes {
  name: string;
  code: string;
}

function ProfileCodeList(): ReactElement {
  const { profileCodeId } = useParams<IProfileCodeListRouteState>();
  const [profileCode, setProfileCode] = useState<IProfileCodes[]>([]);

  useEffect(() => {
    setProfileCode(profileCodes[parseInt(profileCodeId, 10)].codes);
  }, [profileCodeId]);

  const ProfileCodeTableMemo = useMemo(
    () => (
      <Table noItems={profileCode?.length === 0} colsNames={['Nome', 'Code']}>
        {profileCode?.map((item) => (
          <tr key={item.name}>
            <td style={{ width: '50%' }}>{item.name}</td>
            <td style={{ paddingLeft: 0, textAlign: 'center' }}>{item.code}</td>
          </tr>
        ))}
      </Table>
    ),
    [profileCode],
  );

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>{profileCodes[parseInt(profileCodeId, 10)].name}</S.Title>
        </S.Header>
        {ProfileCodeTableMemo}
        <S.Footer />
      </S.Container>
    </>
  );
}

export default ProfileCodeList;
